export default "__VITE_ASSET__C$jGv7lI__"